import { apiClient } from "../../api/httpClient";

const REGISTER_PATH = "/register-lawfirm-guardian";

const PG_DUPLICATE_EMAIL_MSG =
  "Registration Failed. A professional guardian with this email already exists. Please contact support for assistance.";

function mapUiUserTypeToApi(userType, formData) {
  if (userType === "individual_pg") {
    return "professional_guardian";
  }
  if (userType === "corporate_pg") {
    return "professional_guardian";
  }
  if (userType === "professional_guardian" && formData.is_corporate_pg) {
    return "professional_guardian";
  }
  return userType;
}

export function buildFirstTimeRegisterPayload({
  userType,
  formData,
  lawFirmData,
  corporateContacts,
}) {
  const apiUserType = mapUiUserTypeToApi(userType, formData);
  const payload = {
    username: formData.username?.trim(),
    email: formData.email?.trim(),
    password: formData.password,
    first_name: formData.firstName?.trim(),
    last_name: formData.lastName?.trim(),
    user_type: apiUserType,
  };

  if (userType === "lawfirm_user" || userType === "law_firm_user") {
    payload.lawfirm_id = lawFirmData.lawFirm;
    payload.law_firm_location_id = lawFirmData.lawFirmLocation;
    payload.position = formData.position?.trim();
    return payload;
  }

  const isCorporate =
    userType === "corporate_pg" ||
    (userType === "professional_guardian" && formData.is_corporate_pg);

  const dob = formData.dateOfBirth?.trim();
  if (dob) {
    payload.date_of_birth = dob;
  }

  if (userType === "independent_paralegal") {
    payload.lawfirm_id = lawFirmData.lawFirm;
    payload.law_firm_location_id = lawFirmData.lawFirmLocation;
    payload.phone_number = formData.phoneNumber?.trim();
    payload.address = formData.address?.trim();
    return payload;
  }

  payload.phone_number = formData.phoneNumber?.trim();
  payload.address = formData.address?.trim();

  if (isCorporate) {
    payload.is_corporate_pg = true;
    payload.business_name = formData.business_name?.trim();
    payload.contacts = (corporateContacts || []).map((c) => ({
      full_name: c.full_name?.trim(),
      email: c.email?.trim(),
      phone_number: c.phone_number?.trim() || "",
      is_admin: Boolean(c.is_admin),
    }));
  } else {
    payload.is_corporate_pg = false;
  }

  return payload;
}

function showFieldErrors(errorData, toast) {
  if (!errorData || typeof errorData !== "object") return false;
  let shown = false;

  Object.entries(errorData).forEach(([field, messages]) => {
    if (!Array.isArray(messages)) return;
    messages.forEach((msg) => {
      const formatted =
        field === "username" && String(msg).includes("already exists")
          ? "Username already taken."
          : msg;
      toast.error(`${field.charAt(0).toUpperCase() + field.slice(1)}: ${formatted}`);
      shown = true;
    });
  });

  if (errorData.error) {
    toast.error(errorData.error);
    shown = true;
  }
  if (errorData.detail) {
    toast.error(errorData.detail);
    shown = true;
  }

  return shown;
}

function isPgDuplicateEmailError(errorData) {
  if (!errorData || typeof errorData !== "object") return false;
  const emailMsgs = errorData.email;
  if (!Array.isArray(emailMsgs)) return false;
  return emailMsgs.some((msg) =>
    String(msg).toLowerCase().includes("already exists")
  );
}

export async function submitFirstTimeRegister(payload, { navigate, toast }) {
  try {
    await apiClient(REGISTER_PATH, "POST", payload);
    toast.success("Thank you for registering. Please login to continue.");
    navigate("/");
  } catch (error) {
    const errorData = error?.response?.data;
    if (
      payload.user_type === "professional_guardian" &&
      isPgDuplicateEmailError(errorData)
    ) {
      toast.error(PG_DUPLICATE_EMAIL_MSG);
      throw error;
    }
    if (!showFieldErrors(errorData, toast)) {
      const message =
        errorData?.message ||
        error?.message ||
        "Registration failed. Please try again or contact support.";
      toast.error(message);
    }
    throw error;
  }
}
